import './EtapaDadosConta.css';
import logo from '../../../imgs/logo-eqg-white.svg'
import EtapaDadosContaImg from '../../../imgs/step-conta-luz.png'
import { HiOutlineLockClosed } from "react-icons/hi";

function EtapaDadosConta() {

    return (
        <div className='container'>
            <div className='logo'>
                <img alt='logo eu quero grana' src={logo} />
            </div>
            <div className='container-top'>
                <div className='EtapaDadosContaImg'>
                    <img alt='servidores públicos' src={EtapaDadosContaImg} />
                </div>
            </div>
            <div className='containerfooter'>
            </div>
            <div className='textfooter'>
                <div className='locked'><HiOutlineLockClosed /></div>

                <h6>Você está em um ambiente seguro.</h6>
            </div>
        </div>
    );
}

export default EtapaDadosConta;